import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Badge, Menu, Icon, Table, Button, Modal, Spin, Row, Col, Select, Input, Pagination, Form, InputNumber } from 'antd';
import cn from 'classnames';
import { getClassOrders } from 'data/class';
import classes from '../styles/class/ClassInfo.module.scss';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';

import { isEmpty, merge } from 'lodash';
import { useDispatch } from 'react-redux';
import { formatNumber } from 'utils/formatting';
import { TableHelper, exportAsExcel } from 'helpers/Table';
import moment from 'moment';
import Utils from 'utils/utils';
const remainingThreshold = 3;
const pageLimit = 20;
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const ClassOrder = ({ classroom }) => {
  const [orderItems, setOrderItems] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isShowOrderModal, setIsShowOrderModal] = useState(false);
  const [sortBy, setSortBy] = useState('');

  const fetchOrders = async (query = {}) => {
    setLoading(true);
    const _orderItems = await getClassOrders(classroom._id, query);
    setLoading(false);
    setOrderItems(_orderItems);
  };
  useEffect(() => {
    fetchOrders({});
  }, []);

  // if (query.type === 'fb') {
  //   Router.push('/');
  // }
  if (!orderItems) {
    return <div></div>;
  }

  const onChangePage = (page) => {
    // this.getOrders(_.merge(this.getCurrentQuery(), { page }));
    // this.setState({
    //   page,
    //   selectedRowKeys: [],
    // });
  };

  const onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    if (order === 'descend') {
      const newSortBy = `-${field}`;
      setSortBy(`-${field}`);
      fetchOrders({ sortBy: newSortBy });
    } else if (order === 'ascend') {
      const newSortBy = field;
      setSortBy(newSortBy);
      fetchOrders({ sortBy: newSortBy });
    }
  };

  const content = orderItems.results.map((singleContent, key) => {
    singleContent.key = key;
    return singleContent;
  });

  const handleEditOrder = () => {};

  const renderEditRemarkModal = () => {
    return (
      <Modal
        title={'Class Order'}
        visible={isShowOrderModal}
        onCancel={() => setIsShowOrderModal(false)}
        footer={[
          <Button key="submit" type="primary" size="large" loading={loading} onClick={handleEditOrder}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={() => setIsShowOrderModal(false)}>
            Cancel
          </Button>,
        ]}
      >
        {/* <Form onSubmit={this.handleEditOrder}>
          <FormItem {...formItemLayout} label="Order">
            {getFieldDecorator('recommendedOrder', {
              initialValue: selectedClassroom.recommendedOrder,
            })(<InputNumber />)}
          </FormItem>
        </Form> */}
      </Modal>
    );
  };

  return (
    <div>
      <Spin tip="Loading" size="large" spinning={!!loading}>
        <div className="content">
          <div>
            <Table columns={columns} dataSource={content} bordered pagination={false} onChange={onTableChange} scroll={{ x: 1400 }} />
            <Pagination className={cn(classes.pagination, 'text-right')} current={orderItems.currentPage} onChange={onChangePage} defaultPageSize={pageLimit} total={orderItems.count} />
          </div>
        </div>
      </Spin>
      {renderEditRemarkModal()}
    </div>
  );
};

export default connect((state) => ({}), {})(ClassOrder);

const columns = [
  {
    ...TableHelper.defaultColumn('RefNo', 'refNo'),
    render: (value, record) => (
      <div className="no-wrap">
        <Link to={`/order/${_.get(record, 'order._id')}`}>{_.get(record, 'order.refNo')} </Link>
        {record.remark && <Icon type="pushpin" />}
      </div>
    ),
  },
  {
    ...TableHelper.defaultColumn('Code', 'code'),
    render: (value, record) => (
      <div className="no-wrap">
        <Link to={`/order-item/${record._id}`}>{value} </Link>
      </div>
    ),
  },
  {
    ...TableHelper.datetimeColumn('Order\nDate &\nTime', 'createdAt'),
    sorter: true,
  },

  {
    ...TableHelper.defaultColumn('Student', 'studentName'),
    render: (value, record) => <Link to={`/student/${record.student._id}`}>{record.student && record.student.name ? `${record.student.name.first} ${record.student.name.last}` : 'not exist'}</Link>,
    renderExcel: (value, record) => <span>{record.student && record.student.name ? `${record.student.name.first} ${record.student.name.last}` : 'not exist'}</span>,
  },
  {
    ...TableHelper.defaultColumn('Sex', 'student.gender'),
  },
  {
    ...TableHelper.defaultColumn('Age', 'student.birthday'),
    render: (value) => {
      if (!value) return '';
      const age = moment().diff(moment(value), 'years');
      return age;
    },
  },
  {
    ...TableHelper.integerColumn('Learned', 'student.studiedWithTeacherCount'),
    render: (value, record) => {
      if (record.paymentMethod === 'Total') {
        return '';
      }
      const learned = record.learned || record.learned === 0 ? record.learned : value;
      return learned ? formatNumber(learned, '0,0') : 0;
    },
  },
  {
    ...TableHelper.defaultColumn('Status', 'status'),
    render: (value) => {
      if (value === 'Total') return value;
      return (
        <div>
          {value === 'pending' && <Badge status="default" text="Pending" />}
          {value === 'confirm' && <Badge status="warning" text="Confirmed" />}
          {value === 'paid' && <Badge status="processing" text="Paid" />}
          {value === 'success' && <Badge status="success" text="Success" />}
          {value === 'rejected' && <Badge status="error" text="Cancelled" />}
          {value === 'refunded' && <Badge status="warning" text="Refunded" />}
        </div>
      );
    },
    sorter: true,
  },
  {
    ...TableHelper.defaultColumn('Payment\nMethod', 'paymentMethod', true),
    render: (value) => {
      if (value === 'Total') return value;
      return (
        <div>
          {value === 'transfer' && 'Transfer'}
          {value === 'cc' && 'Credit Card'}
        </div>
      );
    },
  },

  {
    ...TableHelper.priceColumn('Payout', 'teacherRevenue'),
  },
  {
    ...TableHelper.datetimeColumn('Payout\nDate', 'withdrawal.approvedDate'), // withdrawal
  },
  // {
  //   ...TableHelper.defaultColumn('With\nCode', 'withdrawal.code'), // withdrawal
  //   render: (value, record) => (
  //     <div className="no-wrap">
  //       <Link to={`/withdraw/${_.get(record, 'withdrawal._id')}`}>{value}</Link>
  //     </div>
  //   ),
  //   renderExcel: (value, record) => value,
  // },
  {
    ...TableHelper.priceColumn('Teacher’s\nRev', 'price'),
    // render: (value, record) => {
    //   if (record.serviceFee === 0) {
    //     return '-';
    //   }
    //   return `${formatNumber(record.paidPrice - record.serviceFee, '0,0.00')}`;
    // },
  },
  {
    ...TableHelper.priceColumn('Net Com', 'serviceFee'),
    render: (value, record) => formatNumber(value - record.cardFee, '0,0.00'),
    renderExcel: (value, record) => formatNumber(value - record.cardFee, '0.00'),
  },

  {
    ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
  },
  {
    ...TableHelper.percentColumn('%Com', 'feePercentage'),
  },
];
